<template>
  <div
    v-show="reservation && display_timer && !checkout_success"
    id="reservation-checkout-timer"
    class="flex flex-col items-baseline gap-0 text-sm"
    :class="{ 'text-alerts-warning': isLessThan3Minutes }"
  >
    <p id="holding-text">{{ holdingText }}</p>
    <p id="time" class="font-semibold">{{ formattedTime }}</p>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import useReservationCountdown from '@/common/composables/useReservationCountdown'
import { useCheckoutStore } from '@/stores/checkout'
import { useSettingStore } from '@/stores/setting'

const settingStore = useSettingStore()
const { display_timer } = storeToRefs(settingStore)
const checkoutStore = useCheckoutStore()
const { checkout_success, reservation } = storeToRefs(checkoutStore)

const { formattedTime, isLessThan3Minutes, holdingText } = useReservationCountdown()
</script>
